/* eslint-disable @typescript-eslint/no-misused-promises */
import { useTranslation } from 'react-i18next'

import { useMove, useSelectQuoteAction, useSelectedQuote } from '../../../modules/moves'
import Button, { ButtonColor, ButtonSize } from '../../../components/Button'
import { useErrorFormatter } from '../../../components/errors/useErrorFormatter'
import Spinner from '../../../components/Spinner'
import { errorNotification } from '../../../components/ToastNotifications'
import QuoteComponent from '../../../components/QuoteComponent'

const SelectedQuote: React.FC = () => {
  const { t } = useTranslation()
  const selectedQuote = useSelectedQuote()
  const { data: move } = useMove()
  const [selectQuote, { loading: unselecting }] = useSelectQuoteAction()
  const formatError = useErrorFormatter()

  if (!move || !selectedQuote) {
    return null
  }

  const { hasCustomQuote, isLongDistance } = move.state
  const canChangeQuote = !hasCustomQuote || (isLongDistance && (move.quotes?.length ?? 0) > 1)

  const clearSelection = async () => {
    try {
      await selectQuote(null)
    } catch (error) {
      errorNotification(formatError(error))
    }
  }

  return (
    <>
      { unselecting && (
        <Spinner floating backdrop />
      ) }

      <div className="flex min-h-[135px] grow flex-col items-center justify-between gap-x-4 overflow-hidden rounded-xl border bg-white py-6 shadow-xl sm:flex-row sm:pr-8 md:py-0">
        <div>
          <QuoteComponent
            quote={selectedQuote}
            options={{
              cardMode: true,
            }}
          />
        </div>

        { canChangeQuote && (
          <div className="pt-4 sm:pt-0">
            <Button
              onClick={clearSelection}
              size={ButtonSize.Small}
              color={ButtonColor.Secondary}
            >
              { t('actions.change') }
            </Button>
          </div>
        ) }
      </div>
    </>
  )
}

export default SelectedQuote
